<ng-container>
  <ng-container [ngSwitch]="paymentProviderId">
    <div
      data-cy="payment-provider-info__title"
      *ngSwitchCase="paymentProvider.CYBERSOURCE"
      class="body--s text-grey">
      {{ 'checkout.digitalNativeCheckout.paymentType.cc.cyberSourceInfo1' | cxTranslate }}
      <udex-link
        class="body--s"
        target="_blank"
        design="Default"
        href="{{ 'checkout.digitalNativeCheckout.paymentType.cc.cyberSourcePrivacyLink' | cxTranslate }}"
      >{{ ('checkout.digitalNativeCheckout.paymentType.cc.cyberSourcePrivacyLink' | cxTranslate) }}
      </udex-link>
      {{ 'checkout.digitalNativeCheckout.paymentType.cc.cyberSourceInfo2' | cxTranslate }}
    </div>

    <div
      data-cy="payment-provider-info__title"
      *ngSwitchCase="paymentProvider.STRIPE"
      class="body--s text-grey">
      {{ 'checkout.digitalNativeCheckout.paymentType.cc.stripeInfo' | cxTranslate }}(
      <udex-link
        class="body--s"
        target="_blank"
        design="Default"
        href="{{ 'checkout.digitalNativeCheckout.paymentType.cc.stripePrivacyLink' | cxTranslate }}"
      >{{ ('checkout.digitalNativeCheckout.paymentType.cc.stripePrivacyLink' | cxTranslate) }}
      </udex-link>
      ), {{ ('checkout.digitalNativeCheckout.paymentType.cc.stripeDisclosure' | cxTranslate) }}
    </div>

    <div
      data-cy="payment-provider-info__title" *ngSwitchCase="paymentProvider.DELEGO"
      class="body--s text-grey">{{ 'checkout.digitalNativeCheckout.paymentType.cc.delegoInfo' | cxTranslate }}
    </div>

    <div
      data-cy="payment-provider-info__title" *ngSwitchCase="paymentProvider.MOCK_STRIPE"
      class="body--s text-grey">{{ 'checkout.digitalNativeCheckout.paymentType.cc.stripeInfo' | cxTranslate }}
    </div>

  </ng-container>
  <div
    *ngIf="paymentProviderId !== paymentProvider.CYBERSOURCE"
    class="body--s text-grey udex-pt-16 udex-pt-sm-0"
    data-testid="message-cc-disclaimer-container"
    data-cy="cc-disclaimer">
    <strong>{{ 'checkout.digitalNativeCheckout.paymentType.cc.note' | cxTranslate }}</strong>
    {{
      'checkout.digitalNativeCheckout.paymentType.cc.disclaimer' | cxTranslate: {
        currencyAmount: currencyAmount,
        currencyIso: currencyIso
      }
    }}
  </div>

  <ng-container *ngIf="userPaymentMethods?.length && showCreditCardDropdown">
    <div class="select-box-preview udex-mt-20">
      <udex-select-box
        mode="SingleSelect"
        height="300px"
        [search-placeholder]="'checkout.digitalNativeCheckout.paymentType.cc.string'| cxTranslate"
        value-state="Standard"
        (selection-change)="selectedCreditCardValueChanged($event)"
      >
        <udex-select-box-item
          *ngFor="let item of userPaymentMethods"
          [label]="item.cardType?.name + '   ' + ('checkout.digitalNativeCheckout.paymentType.cc.dropdown.cardNumberHidden' | cxTranslate) + ' ' + fetchLastCreditCardDigits(item.cardNumber)"
          [value]="item.id"
          [selected]="selectedPaymentDetailsId === item.id"
        >
        </udex-select-box-item>
        <udex-select-box-item
          [label]="'checkout.digitalNativeCheckout.paymentType.cc.dropdown.addNewCard' | cxTranslate"
          [value]="addNewCardAction">
        </udex-select-box-item>
      </udex-select-box>
    </div>
  </ng-container>
  <ng-container *ngIf="showCCError">
    <udex-status-message
      data-cy="cc-error"
      [attr.supporting-text]="'checkout.digitalNativeCheckout.paymentType.cc.error' | cxTranslate"
      value-state="Error"
    ></udex-status-message>
  </ng-container>

  <div class="udex-pt-20">
    <ng-container [ngSwitch]="paymentProviderId">
      <dcp-delego-add-new-cc
        *ngSwitchCase="paymentProvider.DELEGO"
        [attr.data-cy]="'add-new-cc-' + paymentProvider.DELEGO"
        [isClosable]="!!userPaymentMethods?.length"
      ></dcp-delego-add-new-cc>
      <dcp-stripe-add-new-cc
        *ngSwitchCase="paymentProvider.STRIPE"
        [attr.data-cy]="'add-new-cc-' + paymentProvider.STRIPE"
        [isClosable]="!!userPaymentMethods?.length"
      ></dcp-stripe-add-new-cc>
      <dcp-cyber-source-add-new-cc
        *ngSwitchCase="paymentProvider.CYBERSOURCE"
        [attr.data-cy]="'add-new-cc-' + paymentProvider.CYBERSOURCE"
        [isClosable]="!!userPaymentMethods?.length"
        [sessionRefreshed]="paymentProviderFormRefreshMsg"
      ></dcp-cyber-source-add-new-cc>
      <dcp-mock-add-new-cc
        *ngSwitchCase="paymentProvider.MOCK_STRIPE"
        [attr.data-cy]="'add-new-cc-' + paymentProvider.MOCK_STRIPE"
        [isClosable]="!!userPaymentMethods?.length"
      ></dcp-mock-add-new-cc>
    </ng-container>
  </div>

</ng-container>

<dcp-billing-information
  data-cy="credit-card-billing-information"
  [invoiceContacts]="invoiceContacts"
  [invoiceAddresses]="invoiceAddresses">
</dcp-billing-information>

